// extracted by mini-css-extract-plugin
module.exports = {"todo":"Todo_todo__122oA"};